module.exports = __webpack_public_path__ + "static/media/icon-hide.8e4cf066.png";